import React, {useEffect, useMemo, useState} from 'react';
import {Input} from "antd";
import {FiSearch} from "react-icons/fi"
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {changeSearch} from "../../../../redux/actions/layout/interaction/action";
import {t} from "i18next";

function HeaderSearch(props) {
    const [searchParams] = useSearchParams()
    const [value, setValue] = useState(searchParams.get("search") || "")
    const [flag, setFlag] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();

    useEffect(() => {
        if (flag) {
            const delayDebounceFn = setTimeout(() => {
                if (value === "") {
                    searchParams.delete("search")
                } else {
                    searchParams.delete("search")
                    searchParams.append("search", value)
                }
                navigate(`?${searchParams.toString()}`)

            }, 500)
            setFlag(false)
            return () => clearTimeout(delayDebounceFn)
        }
    }, [value])

    useMemo(() => {
        const str = searchParams.get("search") || null
        dispatch(dispatch(changeSearch(str)))
        setValue(str || "")
    }, [searchParams.get("search")])

    return (
        <Input
            value={value}
            placeholder={t("tnp.components.common.text25")}
            allowClear={true}
            prefix={<FiSearch className={"text-[17px]"}/>}
            className={!props.className ?
                "custom-search mr-[var(--header-item-margin-third)] h-[44px] w-[393px] rounded-lg px-[15px]" :
                "custom-search mx-[12px] w-[30%] rounded-lg px-[15px]"
        }
            onChange={e => {
                setValue(e.target.value)
                setFlag(true)
            }}
        />
    );
}

export default HeaderSearch;